import { Directive, ElementRef, HostListener, Input } from '@angular/core';

import { AnalyticsService } from '@libs/src/analytics/analytics.service';

@Directive({
  selector: '[appTrackClick]',
})
export class TrackClickDirective {
  static EVENT_NAME = 'Element Clicked';
  @Input() elementCustomId: string;

  constructor(
    private readonly analyticsService: AnalyticsService,
    private readonly element: ElementRef,
  ) {}

  @HostListener('click')
  click() {
    const nativeElement = this.element.nativeElement;
    if (!nativeElement) {
      return;
    }
    const trimmedText =
      nativeElement.textContent && nativeElement.textContent.trim();
    this.analyticsService.eventTrack(TrackClickDirective.EVENT_NAME, {
      ...(this.elementCustomId && { elementCustomId: this.elementCustomId }),
      elementType: nativeElement.nodeName,
      textContent: trimmedText,
    });
  }
}
